import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

const BeforeAfter = ({ before, after, alt, className = "" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const move = (clientX) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    setPos(Math.min(97, Math.max(3, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div
      ref={ref}
      className={`relative touch-none select-none overflow-hidden ${className}`}
      onPointerDown={(e) => {
        e.currentTarget.setPointerCapture?.(e.pointerId);
        move(e.clientX);
      }}
      onPointerMove={(e) => {
        if (e.buttons === 1) move(e.clientX);
      }}
      role="slider"
      aria-label="Before and after comparison slider"
      aria-valuenow={Math.round(pos)}
      aria-valuemin={0}
      aria-valuemax={100}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") setPos((p) => Math.max(3, p - 5));
        if (e.key === "ArrowRight") setPos((p) => Math.min(97, p + 5));
      }}
      data-testid="ba-slider"
    >
      <img src={after} alt={`${alt} — after detailing`} className="absolute inset-0 h-full w-full object-cover" draggable={false} />
      <img
        src={before}
        alt={`${alt} — before detailing`}
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable={false}
      />
      <div className="absolute inset-y-0 w-px bg-white/90" style={{ left: `${pos}%` }} aria-hidden="true">
        <span className="absolute left-1/2 top-1/2 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-white/60 bg-obsidian/85 text-white backdrop-blur-sm">
          <ChevronsLeftRight size={16} strokeWidth={2.2} />
        </span>
      </div>
      <span className="absolute left-3 top-3 bg-obsidian/80 px-2 py-1 font-mono text-[9px] font-semibold uppercase tracking-[0.2em] text-slate-300">
        Before
      </span>
      <span className="absolute right-3 top-3 bg-obsidian/80 px-2 py-1 font-mono text-[9px] font-semibold uppercase tracking-[0.2em] text-blue-400">
        After
      </span>
    </div>
  );
};

export default BeforeAfter;
